// @flow

import React from "react";
import styles from "./actionButton.scss";

type ActionButtonProps = {
  button: Object,
  rowData: Object,
  modalTheme?: Object
};

type RenderActionButtonProps = {
  buttonConfig: Array<Object>,
  rowData: Object,
  modalTheme?: Object
};

export const ActionButton = (props: ActionButtonProps) => (
  <div
    className={`${
      props.modalTheme && props.modalTheme.name
        ? styles[props.modalTheme.name]
        : ""
    } ${styles.actionButtonWrapper}`}
    onClick={() => props.button.onClick(props.rowData)}
  >
    <div className={styles.iconContainer}>
      <img className={styles.image} src={props.button.iconRef} alt="img" />
    </div>
    <div className={styles.label}>
      {typeof props.button.label === "function"
        ? props.button.label(props.rowData)
        : props.button.label}
    </div>
  </div>
);

export const ActionButtonRetail = (props: ActionButtonProps) => (
  <div
    className={`${
      props.modalTheme && props.modalTheme.name
        ? styles[props.modalTheme.name]
        : ""
    } ${styles.actionButtonRetailWrapper}`}
    onClick={() => props.button.onClick(props.rowData)}
  >
    <div className={`${styles.actionButtonRetail} action-button-retail`}>
      {props.button.label}
    </div>
  </div>
);

export const RenderActionButtons = (props: RenderActionButtonProps) => (
  <div
    className={`${
      props.modalTheme && props.modalTheme.name
        ? styles[props.modalTheme.name]
        : ""
    } ${styles.actionButtonsGroup}`}
  >
    {props.buttonConfig.map((button, index) => (
      <div key={index} style={button.style}>
        {button.hide && button.hide(props.rowData) ? (
          ""
        ) : (
          <ActionButton
            button={button}
            rowData={props.rowData}
            modalTheme={props.modalTheme}
          />
        )}
      </div>
    ))}
  </div>
);

export const RenderRetailActionButtons = (props: RenderActionButtonProps) => (
  <div
    className={`${
      props.modalTheme && props.modalTheme.name
        ? styles[props.modalTheme.name]
        : ""
    }`}
  >
    {props.buttonConfig.map((button, index) => (
      <div key={index}>
        {button.hide && button.hide(props.rowData) ? (
          ""
        ) : (
          <ActionButtonRetail
            button={button}
            rowData={props.rowData}
            modalTheme={props.modalTheme}
          />
        )}
      </div>
    ))}
  </div>
);

ActionButton.defaultProps = {
  modalTheme: { name: null }
};

ActionButtonRetail.defaultProps = {
  modalTheme: { name: null }
};

RenderActionButtons.defaultProps = {
  modalTheme: { name: null }
};

RenderRetailActionButtons.defaultProps = {
  modalTheme: { name: null }
};



// WEBPACK FOOTER //
// ./app/components/commons/actionButton/actionButton.js